module.exports = __webpack_public_path__ + "static/media/Background.6efce9c5.jpg";